module.exports = "<div class=\"glance\">\n  <div class=\"value\">{{value}}</div>\n  <div class=\"text\">{{text}}</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/common/glance/glance.component.html
// module id = 1530
// module chunks = 2